export default __webpack_public_path__ + "static/media/V2-CARROUSEL_2.e6db18d5.jpg";